import React from "react";
import {
  Box,
  Grid,
  Typography,
  Container,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";

// Styled Components
const PageSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(10, 0),
  position: "relative",
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  position: "relative",
  fontWeight: 700,
  paddingBottom: theme.spacing(2),
  display: "inline-block",
  "&::after": {
    content: '""',
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "80px",
    height: "4px",
    backgroundColor: "#C10E14",
  },
}));
const ServiceBox = styled(Box)(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: "10px",
  padding: theme.spacing(3),
  textAlign: "center",
  boxShadow: "0 5px 15px rgba(0, 0, 0, 0.08)",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  "&:hover": {
    transform: "translateY(-5px)",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
  },
}));

const WhatWeDo = () => {
  const services = [
    {
      title: "Buy Property in Dubai",
      description:
        "From family homes to off-plan investments, we connect buyers with verified listings and seamless purchasing experiences.",
    },
    {
      title: "Sell Property in Dubai",
      description:
        "We help homeowners and investors sell properties at optimal value through targeted marketing and strategic sales approaches.",
    },
    {
      title: "Rent Property in Dubai",
      description:
        "Whether long-term residence or short-term leases, we offer diverse rental options for all lifestyles and requirements.",
    },
    {
      title: "Property Leasing",
      description:
        "Property owners trust us to manage their rentals efficiently with comprehensive tenant screening, documentation, and asset protection.",
    },
    {
      title: "Luxury Sales and Rentals",
      description:
        "We specialize in premium real estate, serving high-net-worth clients seeking exclusivity and top-tier service excellence.",
    },
    {
      title: "Investment Property Sales",
      description:
        "We guide investors through profitable exits, resale strategies and ROI optimization for maximum returns.",
    },
  ];
  return (
    <PageSection sx={{ bgcolor: "#f8f9fc" }}>
      <Container>
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <SectionTitle variant="h4" component="h2">
            What We Do
          </SectionTitle>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{ maxWidth: "800px", mx: "auto", mt: 2 }}
          >
            At DESCO Real Estate, we provide end-to-end real estate services
            tailored to every client type and property need
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} md={6} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <ServiceBox>
                  <Typography
                    variant="h6"
                    component="h3"
                    gutterBottom
                    fontWeight={600}
                    color="#C10E14"
                  >
                    {service.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ lineHeight: 1.6 }}
                  >
                    {service.description}
                  </Typography>
                </ServiceBox>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </PageSection>
  );
};

export default WhatWeDo;
